import React from 'react';

import WhatsAppLogo from '../../../../assets/images/whatsapp.svg';
import { useHistory } from 'react-router-dom';
import { Button, Icon } from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import {
  Container,
  IconLabelContainer,
  HorizontalRule,
} from './ChannelDescriptionBanner.styles';

export default function ChannelDescriptionBannerInstagram() {
  const history = useHistory();
  
  // Traduções
  const webhooksDescription = useGlotaT('spa.certification.webhooksDescription');
  return (
    <>
      <Container>
        <IconLabelContainer>
          <Icon
            icon={'poli-icon pi-instagram-fill'}
            color="#ff647c"
            size={40}
          />

          <b>Instagram</b>
        </IconLabelContainer>

        <div>
          {webhooksDescription}
        </div>

        {/* Não está sendo utilizado por enquanto, mas vou deixar aqui caso queiramos reutilizar*/}
        {/* <Button
          color="primary"
          onClick={() => history.push('/tools/channels/add')}
          style={{
            width: '30rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              display: 'flex',
              gap: '0.1rem',
              alignItems: 'center',
            }}
          >
            <Icon icon={'poli-icon pi-add-line'} size={20} />
            <span> Adicionar Canal</span>
          </span>
          <Icon icon={'poli-icon pi-simple-arrow-down-line'} size={20} />
        </Button> */}
      </Container>
      <HorizontalRule />
    </>
  );
}
